/* eslint-disable @nx/enforce-module-boundaries */
'use-client';

import { ProfilePublicView } from 'v4/snippets/profile/public';
import { ProfileLayout } from 'v4/snippets/profile/public/layout';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';

const PublicProfilePage = () => {
  return (
    <AuthenticatedProviders>
      <ProfileLayout>
        <ProfilePublicView />
      </ProfileLayout>
    </AuthenticatedProviders>
  );
};

export default PublicProfilePage;
